/* Fumerlabs CRO JavaScript — High Converting Dawn */
(function(){
  'use strict';

  /* ==========================
     STICKY ADD TO CART
  ========================== */
  function initStickyATC() {
    const submitBtn = document.querySelector('.product-form__submit');
    if (!submitBtn) return;

    const titleEl = document.querySelector('.product__title, h1.product-title');
    const priceEl = document.querySelector('.price__regular .price-item, .price-item--regular');

    const bar = document.createElement('div');
    bar.className = 'cro-sticky-atc';
    bar.innerHTML = [
      '<div class="cro-sticky-atc__info">',
        '<div class="cro-sticky-atc__title">' + (titleEl ? titleEl.textContent.trim() : '') + '</div>',
        '<div class="cro-sticky-atc__price">' + (priceEl ? priceEl.textContent.trim() : '') + '</div>',
      '</div>',
      '<button class="cro-sticky-atc__btn" aria-label="Add to cart">Add to Cart</button>'
    ].join('');
    document.body.appendChild(bar);

    bar.querySelector('.cro-sticky-atc__btn').addEventListener('click', function() {
      submitBtn.click();
    });

    const io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        bar.classList.toggle('is-visible', !e.isIntersecting);
      });
    });
    io.observe(submitBtn);
  }

  /* ==========================
     COUNTDOWN TIMER
  ========================== */
  function initCountdowns() {
    document.querySelectorAll('[data-cro-countdown]').forEach(function(el) {
      var ms = parseInt(el.dataset.croCountdown, 10) || (3 * 60 * 60 * 1000);
      var end = Date.now() + ms;

      // Persist via sessionStorage per product
      var key = 'cro_cd_' + (el.dataset.croCountdownKey || 'global');
      if (sessionStorage.getItem(key)) {
        end = parseInt(sessionStorage.getItem(key), 10);
      } else {
        sessionStorage.setItem(key, end);
      }

      function tick() {
        var diff = Math.max(0, end - Date.now());
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        var pad = function(n){ return String(n).padStart(2,'0'); };
        var hEl = el.querySelector('.cro-cd-h');
        var mEl = el.querySelector('.cro-cd-m');
        var sEl = el.querySelector('.cro-cd-s');
        if (hEl) hEl.textContent = pad(h);
        if (mEl) mEl.textContent = pad(m);
        if (sEl) sEl.textContent = pad(s);
        if (diff === 0) {
          clearInterval(timer);
          el.innerHTML = '<span style="color:#888">Offer ended</span>';
        }
      }
      tick();
      var timer = setInterval(tick, 1000);
    });
  }

  /* ==========================
     LIVE VIEWER COUNT
  ========================== */
  function initLiveViewers() {
    document.querySelectorAll('[data-cro-live-viewers]').forEach(function(el) {
      var base = 8 + Math.floor(Math.random() * 15);
      el.textContent = base + ' people viewing this right now';
      setInterval(function() {
        base = Math.max(3, base + Math.floor(Math.random() * 5) - 2);
        el.textContent = base + ' people viewing this right now';
      }, 25000);
    });
  }

  /* ==========================
     SHIPPING PROGRESS BAR
  ========================== */
  function initShippingProgress() {
    var bars = document.querySelectorAll('[data-cro-ship-threshold]');
    if (!bars.length) return;

    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart) {
      var total = cart.total_price / 100;
      bars.forEach(function(bar) {
        var threshold = parseFloat(bar.dataset.croShipThreshold) || 5000;
        var pct = Math.min(100, (total / threshold) * 100);
        var fill = bar.querySelector('.cro-shipping-progress__fill');
        var text = bar.querySelector('.cro-shipping-progress__text');
        if (fill) fill.style.width = pct + '%';
        if (text) {
          if (total >= threshold) {
            text.innerHTML = '&#127881; You\'ve unlocked <strong>FREE shipping!</strong>';
          } else {
            var rem = (threshold - total).toFixed(0);
            text.innerHTML = 'Add <strong>PKR ' + rem + '</strong> more for FREE shipping';
          }
        }
      });
    });
  }

  /* ==========================
     FADE-IN ANIMATIONS
  ========================== */
  function initFadeIn() {
    if (!('IntersectionObserver' in window)) return;
    var els = document.querySelectorAll('.cro-fade-in');
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    els.forEach(function(el) { io.observe(el); });
  }

  /* ==========================
     RECENTLY VIEWED NUDGE
  ========================== */
  function trackRecentlyViewed() {
    var titleEl = document.querySelector('.product__title, h1.product-title');
    if (!titleEl) return;
    var title = titleEl.textContent.trim();
    var url = window.location.pathname;
    var viewed = JSON.parse(sessionStorage.getItem('cro_viewed') || '[]');
    if (!viewed.find(function(v){ return v.url === url; })) {
      viewed.unshift({ title: title, url: url });
      if (viewed.length > 5) viewed.pop();
      sessionStorage.setItem('cro_viewed', JSON.stringify(viewed));
    }
  }

  /* INIT */
  document.addEventListener('DOMContentLoaded', function() {
    initStickyATC();
    initCountdowns();
    initLiveViewers();
    initShippingProgress();
    initFadeIn();
    trackRecentlyViewed();
  });
})();